import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import DatasetCards from '../components/DatasetCards';
import LedgerTable from '../components/LedgerTable';
import NewsGrid from '../components/NewsGrid';
import { fetchMeta, fetchDatasets, fetchTopMps, fetchNews } from '../api';

function QuoteStrip() {
  return (
    <section className="bg-ink-200/60 border-y border-ink-300/50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 text-center">
        <div className="kicker text-copper-600 mb-5 inline-flex items-center gap-2">
          <span className="h-px w-8 bg-copper-500 inline-block" /> The Spill the Hill promise
        </div>
        <p className="font-serif text-[28px] md:text-[34px] leading-[1.25] text-ink-800 tracking-tight max-w-4xl mx-auto">
          <span className="italic font-light">“</span>We don't recalculate, re-categorise, or estimate.
          Every figure on this site traces back to a public source you can re-verify yourself.<span className="italic font-light">”</span>
        </p>
      </div>
    </section>
  );
}

export default function Home() {
  const [meta, setMeta] = useState(null);
  const [datasets, setDatasets] = useState([]);
  const [topMps, setTopMps] = useState([]);
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      fetchMeta().catch(() => null),
      fetchDatasets().catch(() => ({ datasets: [] })),
      fetchTopMps(12).catch(() => ({ mps: [] })),
      fetchNews(4).catch(() => ({ items: [] })),
    ]).then(([m, d, t, n]) => {
      setMeta(m);
      setDatasets(d.datasets || []);
      setTopMps(t.mps || []);
      setNews(n.items || []);
      setLoading(false);
    });
  }, []);

  return (
    <div className="min-h-screen bg-cream-100 text-ink-700 paper-texture">
      <Header />
      <main>
        <Hero meta={meta} />
        <DatasetCards datasets={datasets} loading={loading} />
        <LedgerTable mps={topMps} meta={meta} loading={loading} />
        <QuoteStrip />
        <NewsGrid items={news} limit={4} loading={loading} />
      </main>
      <Footer meta={meta} />
    </div>
  );
}
